import BoardingCheckinResource from "./boardingCheckin.resource";

const boardingCheckinModule = angular
  .module("app.resources.boardingCheckin", [])
  .service("BoardingCheckin", BoardingCheckinResource);

export default boardingCheckinModule;



// WEBPACK FOOTER //
// ./src/resources/boardingCheckin/boardingCheckin.module.js